'use client';

import { ShoppingBag } from 'lucide-react';
import { Link } from '@/i18n/navigation';
import styles from './TakeawayComingSoon.module.css';

interface TakeawayComingSoonProps {
  eyebrow: string;
  title: string;
  description: string;
  badge: string;
  contactLabel: string;
}

export function TakeawayComingSoon({ eyebrow, title, description, badge, contactLabel }: TakeawayComingSoonProps) {
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <div className={styles.iconWrap}>
          <ShoppingBag className={styles.icon} aria-hidden="true" />
        </div>

        <span className={styles.eyebrow}>{eyebrow}</span>

        <h1 className={styles.title}>{title}</h1>

        <p className={styles.description}>{description}</p>

        <span className={styles.badge}>{badge}</span>

        <Link href="/contact" className={styles.contactButton}>
          {contactLabel}
        </Link>
      </div>
    </div>
  );
}
